/**
 * Project: fuse-react-app
 * FilePath: /src/client/app/sectors/Table/store/actions/index.js
 * File: index.js
 * Created Date: Friday, January 11th 2019, 10:00:17 am
 * Author: Craig Bojko (craig.bojko@anexsys.com)
 * -----
 * Last Modified: Sun Jan 27 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Anexsys
 * ------------------------------------
 */

export * from './projects.actions'
